export const TopicID = "ic-user-tasks";
export const TopicNameRegExp = new RegExp('/ic-user-tasks\\/[A-z]*/');
export const SubscriptionParamsSchema = { type: "null" };
